module.exports = __webpack_public_path__ + "img/logo-white.490286bb.png";